module.exports = __webpack_public_path__ + "img/cha.7e539c2d.png";